import "core-js/modules/es.array.push.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, Teleport as _Teleport } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = {
  key: 0,
  class: "text-[11px] text-slate-400 mb-0.5 ml-1"
};
const _hoisted_3 = {
  class: "font-medium"
};
const _hoisted_4 = {
  class: "truncate"
};
const _hoisted_5 = {
  class: "min-w-0"
};
const _hoisted_6 = {
  class: "text-sm font-medium truncate"
};
const _hoisted_7 = {
  key: 1,
  class: "text-red-400"
};
const _hoisted_8 = {
  class: "flex items-start gap-3 p-3"
};
const _hoisted_9 = ["src", "alt"];
const _hoisted_10 = {
  key: 1,
  class: "w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0"
};
const _hoisted_11 = {
  class: "flex-1 min-w-0"
};
const _hoisted_12 = {
  class: "font-medium text-sm truncate"
};
const _hoisted_13 = ["src", "alt"];
const _hoisted_14 = {
  key: 0,
  class: "absolute inset-0 bg-black/30 flex items-center justify-center"
};
const _hoisted_15 = {
  key: 1,
  class: "absolute inset-0 bg-black/40 flex items-center justify-center"
};
const _hoisted_16 = {
  class: "text-[10px] text-slate-400"
};
const _hoisted_17 = {
  key: 0,
  class: "w-3 h-3 text-slate-300",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_18 = {
  key: 1,
  class: "w-3 h-3 text-slate-400",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_19 = {
  key: 2,
  class: "w-3 h-3 text-primary-500",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_20 = {
  key: 2,
  class: "w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center text-xs font-medium text-white flex-shrink-0 mt-0.5"
};
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { useChatStore } from '@/stores/chat';
import ReadReceiptPopover from './ReadReceiptPopover.vue';
export default {
  __name: 'MessageBubble',
  props: {
    message: {
      type: Object,
      required: true
    },
    isSelf: {
      type: Boolean,
      default: false
    },
    showSender: {
      type: Boolean,
      default: false
    },
    avatarColor: {
      type: String,
      default: 'bg-slate-500'
    },
    conversationType: {
      type: String,
      default: ''
    },
    members: {
      type: Array,
      default: () => []
    },
    currentUserId: {
      type: [String, Number],
      default: ''
    },
    cachedUser: {
      type: Object,
      default: () => ({
        name: '',
        avatar: ''
      })
    }
  },
  emits: ['reply', 'delete', 'previewImage'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const chatStore = useChatStore();

    // 优先使用缓存的用户信息，其次使用消息中的发送者名称
    const displayName = computed(() => props.cachedUser?.name || props.message.senderName || '');
    const displayAvatar = computed(() => props.cachedUser?.avatar || '');
    // 图片消息：优先使用 IndexedDB 缓存的 blob URL
    const resolvedImageUrl = computed(() => {
      if (props.message.type !== 'image') return '';
      return chatStore.getImageUrl(props.message.imageUrl);
    });
    const showContextMenu = ref(false);
    const menuPosition = ref({
      x: 0,
      y: 0
    });
    function handleContextMenu(e) {
      const menuWidth = 140;
      const menuHeight = 120;
      const x = Math.min(e.clientX, window.innerWidth - menuWidth);
      const y = Math.min(e.clientY, window.innerHeight - menuHeight);
      menuPosition.value = {
        x,
        y
      };
      showContextMenu.value = true;
    }
    function handleCopy() {
      if (props.message.content) {
        navigator.clipboard.writeText(props.message.content).then(() => {
          ElMessage.success('已复制到剪贴板');
        }).catch(() => {
          ElMessage.error('复制失败');
        });
      }
      showContextMenu.value = false;
    }
    function handleDownload() {
      const url = props.message.type === 'image' ? resolvedImageUrl.value : props.message.fileUrl;
      if (!url) {
        ElMessage.warning('文件地址不可用');
        showContextMenu.value = false;
        return;
      }
      const a = document.createElement('a');
      a.href = url;
      a.download = props.message.fileName || (props.message.type === 'image' ? '图片' : '文件');
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      showContextMenu.value = false;
    }
    function handleReply() {
      emit('reply', props.message);
      showContextMenu.value = false;
    }
    function handleDelete() {
      emit('delete', props.message.id);
      showContextMenu.value = false;
    }
    function formatMsgTime(timeStr) {
      if (!timeStr) return '';
      const date = new Date(timeStr);
      if (isNaN(date.getTime())) return '';
      return date.toLocaleTimeString('zh-CN', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
    }
    const router = useRouter();
    function handleProductClick() {
      if (props.message.productId) {
        // 跳转到产品详情页
        router.push(`/product/detail/${props.message.productId}`);
      }
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["flex gap-2 py-1 group relative", __props.isSelf ? 'flex-row-reverse' : 'flex-row']),
        onContextmenu: _withModifiers(handleContextMenu, ["prevent"])
      }, [!__props.isSelf && displayAvatar.value ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: displayAvatar.value,
        class: "w-8 h-8 rounded-full object-cover flex-shrink-0 mt-0.5"
      }, null, 8, _hoisted_1)) : !__props.isSelf ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["w-8 h-8 rounded-full flex items-center justify-center text-xs font-medium text-white flex-shrink-0 mt-0.5", __props.avatarColor])
      }, _toDisplayString(displayName.value.slice(-1)), 3)) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass([__props.isSelf ? 'items-end' : 'items-start', "flex flex-col max-w-[65%]"])
      }, [__props.showSender && !__props.isSelf ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(displayName.value), 1)) : _createCommentVNode("", true), __props.message.replyTo ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["px-2.5 py-1.5 mb-0.5 rounded-lg text-[11px] max-w-full cursor-pointer", __props.isSelf ? 'bg-primary-400/40 text-primary-100' : 'bg-slate-100 text-slate-500'])
      }, [_createElementVNode("span", _hoisted_3, _toDisplayString(__props.message.replyTo.senderName), 1), _createElementVNode("p", _hoisted_4, _toDisplayString(__props.message.replyTo.content), 1)], 2)) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(["relative flex items-center gap-1", __props.isSelf ? 'flex-row-reverse' : 'flex-row'])
      }, [__props.message.type === 'text' ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["px-3 py-2 rounded-xl text-sm leading-relaxed whitespace-pre-wrap break-words", __props.isSelf ? 'bg-primary-500 text-white rounded-br-sm' : 'bg-white text-slate-700 border border-slate-200/80 rounded-bl-sm shadow-sm'])
      }, _toDisplayString(__props.message.content), 3)) : __props.message.type === 'file' ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["px-3 py-2.5 rounded-xl flex items-center gap-3 cursor-pointer hover:shadow-md transition-shadow", __props.isSelf ? 'bg-primary-500 text-white rounded-br-sm' : 'bg-white text-slate-700 border border-slate-200/80 rounded-bl-sm shadow-sm'])
      }, [_createElementVNode("div", {
        class: _normalizeClass(["w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0", __props.isSelf ? 'bg-primary-400' : 'bg-primary-50'])
      }, [__props.message.status === 'sending' ? (_openBlock(), _createElementBlock("svg", {
        key: 0,
        class: _normalizeClass(["w-5 h-5 animate-spin", __props.isSelf ? 'text-white' : 'text-primary-500']),
        fill: "none",
        viewBox: "0 0 24 24"
      }, [...(_cache[5] || (_cache[5] = [_createElementVNode("circle", {
        class: "opacity-25",
        cx: "12",
        cy: "12",
        r: "10",
        stroke: "currentColor",
        "stroke-width": "4"
      }, null, -1), _createElementVNode("path", {
        class: "opacity-75",
        fill: "currentColor",
        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      }, null, -1)]))], 2)) : (_openBlock(), _createElementBlock("svg", {
        key: 1,
        class: _normalizeClass(["w-5 h-5", __props.isSelf ? 'text-white' : 'text-primary-500']),
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [...(_cache[6] || (_cache[6] = [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
      }, null, -1)]))], 2))], 2), _createElementVNode("div", _hoisted_5, [_createElementVNode("p", _hoisted_6, _toDisplayString(__props.message.fileName), 1), _createElementVNode("p", {
        class: _normalizeClass(["text-[11px] mt-0.5", __props.isSelf ? 'text-primary-200' : 'text-slate-400'])
      }, [__props.message.status === 'sending' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode("上传中...")], 64)) : __props.message.status === 'failed' ? (_openBlock(), _createElementBlock("span", _hoisted_7, "发送失败")) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [_createTextVNode(_toDisplayString(__props.message.fileSize), 1)], 64))], 2)])], 2)) : __props.message.type === 'product' ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: _normalizeClass(["w-64 rounded-xl overflow-hidden cursor-pointer hover:shadow-md transition-shadow", __props.isSelf ? 'bg-primary-500 text-white rounded-br-sm' : 'bg-white text-slate-700 border border-slate-200/80 rounded-bl-sm shadow-sm']),
        onClick: handleProductClick
      }, [_createElementVNode("div", _hoisted_8, [__props.message.productIcon ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: __props.message.productIcon,
        alt: __props.message.productName,
        class: "w-12 h-12 rounded-lg object-cover flex-shrink-0"
      }, null, 8, _hoisted_9)) : (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[7] || (_cache[7] = [_createElementVNode("svg", {
        class: "w-6 h-6 text-primary-500",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
      })], -1)]))])), _createElementVNode("div", _hoisted_11, [_createElementVNode("p", _hoisted_12, _toDisplayString(__props.message.productName), 1), _createElementVNode("p", {
        class: _normalizeClass(["text-xs mt-0.5 line-clamp-2", __props.isSelf ? 'text-primary-100' : 'text-slate-400'])
      }, _toDisplayString(__props.message.productSummary), 3)])]), _createElementVNode("div", {
        class: _normalizeClass(["px-3 py-2 text-xs text-center border-t", __props.isSelf ? 'border-primary-100' : 'border-slate-100 text-primary-500'])
      }, " 查看产品详情 ", 2)], 2)) : __props.message.type === 'image' ? (_openBlock(), _createElementBlock("div", {
        key: 3,
        class: _normalizeClass(["rounded-xl overflow-hidden cursor-pointer relative", __props.isSelf ? 'rounded-br-sm' : 'rounded-bl-sm']),
        onClick: _cache[0] || (_cache[0] = $event => __props.message.status !== 'sending' && _ctx.$emit('previewImage', resolvedImageUrl.value))
      }, [_createElementVNode("img", {
        src: resolvedImageUrl.value,
        alt: __props.message.content || '图片',
        class: "max-w-[240px] max-h-[240px] object-cover"
      }, null, 8, _hoisted_13), __props.message.status === 'sending' ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[8] || (_cache[8] = [_createElementVNode("svg", {
        class: "w-7 h-7 text-white animate-spin",
        fill: "none",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("circle", {
        class: "opacity-25",
        cx: "12",
        cy: "12",
        r: "10",
        stroke: "currentColor",
        "stroke-width": "4"
      }), _createElementVNode("path", {
        class: "opacity-75",
        fill: "currentColor",
        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      })], -1)]))])) : _createCommentVNode("", true), __props.message.status === 'failed' ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[9] || (_cache[9] = [_createElementVNode("div", {
        class: "text-center"
      }, [_createElementVNode("svg", {
        class: "w-6 h-6 text-red-400 mx-auto",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      })]), _createElementVNode("span", {
        class: "text-white text-xs mt-1 block"
      }, "发送失败")], -1)]))])) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(["hidden group-hover:flex items-center gap-0.5", __props.isSelf ? 'flex-row-reverse' : 'flex-row'])
      }, [_createElementVNode("button", {
        class: "p-1 text-slate-400 hover:text-primary-500 hover:bg-slate-100 rounded transition-colors cursor-pointer",
        title: "回复",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('reply', __props.message))
      }, [...(_cache[10] || (_cache[10] = [_createElementVNode("svg", {
        class: "w-3.5 h-3.5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
      })], -1)]))]), _createElementVNode("button", {
        class: "p-1 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded transition-colors cursor-pointer",
        title: "更多",
        onClick: _cache[2] || (_cache[2] = $event => handleContextMenu($event))
      }, [...(_cache[11] || (_cache[11] = [_createElementVNode("svg", {
        class: "w-3.5 h-3.5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
      })], -1)]))])], 2)], 2), _createElementVNode("div", {
        class: _normalizeClass(["flex items-center gap-1 mt-0.5 mx-1", __props.isSelf ? 'flex-row-reverse' : 'flex-row'])
      }, [_createElementVNode("span", _hoisted_16, _toDisplayString(formatMsgTime(__props.message.time)), 1), __props.isSelf && __props.conversationType === 'group' && __props.message.status !== 'sending' && __props.message.status !== 'failed' ? (_openBlock(), _createBlock(ReadReceiptPopover, {
        key: 0,
        message: __props.message,
        members: __props.members,
        "current-user-id": __props.currentUserId
      }, null, 8, ["message", "members", "current-user-id"])) : __props.isSelf && __props.message.status && __props.conversationType !== 'group' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [__props.message.status === 'sent' ? (_openBlock(), _createElementBlock("svg", _hoisted_17, [...(_cache[12] || (_cache[12] = [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M5 13l4 4L19 7"
      }, null, -1)]))])) : __props.message.status === 'delivered' ? (_openBlock(), _createElementBlock("svg", _hoisted_18, [...(_cache[13] || (_cache[13] = [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M5 13l4 4L19 7"
      }, null, -1)]))])) : __props.message.status === 'read' ? (_openBlock(), _createElementBlock("svg", _hoisted_19, [...(_cache[14] || (_cache[14] = [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M5 13l4 4L19 7"
      }, null, -1)]))])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)], 2)], 2), __props.isSelf ? (_openBlock(), _createElementBlock("div", _hoisted_20, " 我 ")) : _createCommentVNode("", true), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [showContextMenu.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "fixed inset-0 z-[100]",
        onClick: _cache[3] || (_cache[3] = $event => showContextMenu.value = false),
        onContextmenu: _cache[4] || (_cache[4] = _withModifiers($event => showContextMenu.value = false, ["prevent"]))
      }, [_createElementVNode("div", {
        class: "absolute bg-white rounded-lg shadow-lg border border-slate-200 py-1 min-w-[120px] z-[101]",
        style: _normalizeStyle({
          left: menuPosition.value.x + 'px',
          top: menuPosition.value.y + 'px'
        })
      }, [__props.message.type === 'text' ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "w-full px-3 py-1.5 text-sm text-slate-600 hover:bg-slate-50 text-left flex items-center gap-2 cursor-pointer",
        onClick: handleCopy
      }, [...(_cache[15] || (_cache[15] = [_createElementVNode("svg", {
        class: "w-4 h-4 text-slate-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
      })], -1), _createTextVNode(" 复制 ", -1)]))])) : _createCommentVNode("", true), (__props.message.type === 'file' || __props.message.type === 'image') && __props.message.status !== 'sending' && __props.message.status !== 'failed' ? (_openBlock(), _createElementBlock("button", {
        key: 1,
        class: "w-full px-3 py-1.5 text-sm text-slate-600 hover:bg-slate-50 text-left flex items-center gap-2 cursor-pointer",
        onClick: handleDownload
      }, [...(_cache[16] || (_cache[16] = [_createElementVNode("svg", {
        class: "w-4 h-4 text-slate-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
      })], -1), _createTextVNode(" 下载 ", -1)]))])) : _createCommentVNode("", true), _createElementVNode("button", {
        class: "w-full px-3 py-1.5 text-sm text-slate-600 hover:bg-slate-50 text-left flex items-center gap-2 cursor-pointer",
        onClick: handleReply
      }, [...(_cache[17] || (_cache[17] = [_createElementVNode("svg", {
        class: "w-4 h-4 text-slate-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
      })], -1), _createTextVNode(" 引用回复 ", -1)]))]), __props.isSelf ? (_openBlock(), _createElementBlock("button", {
        key: 2,
        class: "w-full px-3 py-1.5 text-sm text-red-500 hover:bg-red-50 text-left flex items-center gap-2 cursor-pointer",
        onClick: handleDelete
      }, [...(_cache[18] || (_cache[18] = [_createElementVNode("svg", {
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
      })], -1), _createTextVNode(" 删除 ", -1)]))])) : _createCommentVNode("", true)], 4)], 32)) : _createCommentVNode("", true)]))], 34);
    };
  }
};